// SEO Reference Mapping - Auto-generated from CSV
// This file maps URLs to their canonical titles and meta descriptions

export interface SEOMapping {
  url: string;
  pageTitle: string;
  metaDescription: string;
}

// Parse CSV data and create mapping object
const csvData = `url,page_title,meta_description
https://danielalbertlaw.com,Top Immigration Lawyer Houston | Daniel Albert Law Firm,"Leading immigration lawyer in Houston, TX specializing in asylum, naturalization, visas & deportation defense. Trilingual services (English/Spanish/Vietnamese). Call (832) 930-3059"
https://danielalbertlaw.com/es,Mejor Abogado de Inmigración Houston | Daniel Albert Law Firm,"Abogado líder de inmigración en Houston, TX especializado en asilo, naturalización, visas y defensa contra deportación. Servicios trilingües (inglés/español/vietnamita). Llame (832) 930-3059"
https://danielalbertlaw.com/vi,Luật Sư Di Trú Hàng Đầu Houston | Daniel Albert Law Firm,"Luật sư di trú hàng đầu tại Houston, TX chuyên về tị nạn, nhập tịch, visa và phòng thủ trục xuất. Dịch vụ ba ngôn ngữ (Anh/Tây Ban Nha/Việt). Gọi (832) 930-3059"
https://danielalbertlaw.com/appointment,Consultation - Top Houston Immigration Lawyer - Daniel Albert Law Firm,"Head office address: 10925 Beechnut St A106, Houston, TX 77072, United States Call for help: ENGLISH (832) 930-3059 SPANISH (832) 356-7254 Mail for information: info@danielalbertlaw.com"
https://danielalbertlaw.com/attorney-daniel-albert,Attorney Daniel Albert - Top Houston Immigration Lawyer - Daniel Albert Law Firm,"Attorney Daniel F. Albert Attorney Daniel F. Albert brings over 20 years of legal expertise and knowledge to his general practice, which consists of immigration, family law, business law, criminal law, personal injury, probate, estate planning, tax law, and real estate. Daniel practiced for many years as an accomplished lawyer at prestigious international law firms"
https://danielalbertlaw.com/blog,Blog - Top Houston Immigration Lawyer - Daniel Albert Law Firm,"11 July, 2025 Marriage Visa (I‑130 & I‑485) Read more 10 July, 2025 Adjustment of Status (I‑485) International Student Comprehensive Steps Read more 10 July, 2025 Employment Visa (H‑1B & L‑1) Read more 10 July, 2025 Student Visa (F‑1) Read more 9 July, 2025 Religious Worker Visa (R‑1 & EB‑4) Read more 12 June, 2025"
https://danielalbertlaw.com/contact,Contact - Top Houston Immigration Lawyer - Daniel Albert Law Firm,"Head office address: 10925 Beechnut St A106, Houston, TX 77072, United States Call for help: ENGLISH (832) 930-3059 SPANISH (832) 356-7254 Mail for information: info@danielalbertlaw.com Contact Our Law Office Have legal questions? We're here to help. Whether you're facing a complex legal matter or just need guidance, our team is ready to support you. Contact"
https://danielalbertlaw.com/our-team,Our Team - Top Houston Immigration Lawyer - Daniel Albert Law Firm,Linh Bui Paralegal Thu Thao Doan Paralegal Angelica Ponce Paralegal June Nguyen Paralegal Subscribe to our newsletter and promotions Subscribe`;

function parseCSV(csv: string): Map<string, SEOMapping> {
  const mapping = new Map<string, SEOMapping>();
  const lines = csv.split('\n');
  
  // Skip header
  for (let i = 1; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) continue;
    
    // Parse CSV line handling quoted fields
    const fields: string[] = [];
    let currentField = '';
    let inQuotes = false;
    
    for (let j = 0; j < line.length; j++) {
      const char = line[j];
      
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        fields.push(currentField);
        currentField = '';
      } else {
        currentField += char;
      }
    }
    fields.push(currentField); // Add last field
    
    if (fields.length >= 2) {
      const url = fields[0].trim();
      const pageTitle = fields[1].trim();
      const metaDescription = fields[2]?.trim() || '';
      
      // Normalize URL to pathname only, lowercase, no trailing slash
      const urlObj = new URL(url);
      const normalizedPath = urlObj.pathname.replace(/\/$/, '').toLowerCase();
      
      mapping.set(normalizedPath || '/', {
        url: urlObj.pathname,
        pageTitle,
        metaDescription
      });
    }
  }
  
  return mapping;
}

export const seoMappings = parseCSV(csvData);

/**
 * Get SEO mapping for a given pathname
 * @param pathname - Current pathname (e.g., /contact, /about)
 * @returns SEO mapping if found, undefined otherwise
 */
export function getSEOMapping(pathname: string): SEOMapping | undefined {
  // Normalize: lowercase, remove trailing slash
  const normalized = pathname.replace(/\/$/, '').toLowerCase();
  return seoMappings.get(normalized || '/');
}

/**
 * Validate if current page has SEO mapping
 */
export function validateSEOMapping(pathname: string): {
  found: boolean;
  mapping?: SEOMapping;
  warning?: string;
} {
  const mapping = getSEOMapping(pathname);
  
  if (!mapping) {
    return {
      found: false,
      warning: `URL sin referencia en CSV: ${pathname}`
    };
  }
  
  return {
    found: true,
    mapping
  };
}

/**
 * Generate SEO validation report for all routes
 */
export function generateSEOReport(routes: string[]): Array<{
  url: string;
  status: 'mapped' | 'missing';
  pageTitle?: string;
  metaDescription?: string;
}> {
  return routes.map(route => {
    const validation = validateSEOMapping(route);
    
    if (validation.found && validation.mapping) {
      return {
        url: route,
        status: 'mapped' as const,
        pageTitle: validation.mapping.pageTitle,
        metaDescription: validation.mapping.metaDescription
      };
    }
    
    return {
      url: route,
      status: 'missing' as const
    };
  });
}
